import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Slice for quarters management
const filterSlice = createSlice({
  name: 'filter',
  initialState:
  {
    quarter:
    {
      year: new Date().getFullYear(),
      quarter: `Q${Math.ceil((new Date().getMonth() + 1) / 3)}`,
      month: 'None',
    },
  },
  reducers: {
    setQuarter: (state, action) => {
      state.quarter = action.payload; // Update selected quarter
    },
  },
});

export const { setQuarter } = filterSlice.actions;
export default filterSlice.reducer;
